<template>
    <a
        class="lds-widget-card"
        target="_blank"
        :href="offer.url"
        :class="offerClasses(offer.params.advantage)"
    >
        <ShowcaseOffersAdvantage
            v-if="uspPlacement === advantagesPlacement.OUTSIDE && offer.params.advantage"
            :advantage="offer.params.advantage.string"
        />
        <div class="lds-widget-card__wrapper">
            <ShowcaseOffersAdvantage
                v-if="uspPlacement === advantagesPlacement.INSIDE && offer.params.advantage"
                :advantage="offer.params.advantage.string"
            />
            <div class="lds-widget-card__row">
                <div class="lds-widget-card__container">
                    <div class="lds-widget-card__img">
                        <img
                            :src="offer.logoUrl"
                            :alt="offer.siteName"
                        >
                    </div>
                    <div class="lds-widget-card__params">
                        <div
                            class="lds-widget-card__block"
                            v-if="offer.params.position"
                        >
                            <ShowcaseOfferParams
                                v-if="offer.params.position"
                                :name="offer.params.position.name"
                                :value="offer.params.position.string"
                                class="lds-widget-card__item_position"
                            />
                        </div>
                        <div class="lds-widget-card__block">
                            <ShowcaseOfferParams
                                v-if="offer.params.income"
                                :name="offer.params.income.name"
                                :value="offer.params.income.string"
                                class="lds-widget-card__item_income"
                                :symbol="currencySymbol"
                            />
                            <ShowcaseOfferParams
                                v-if="offer.params.workSchedule"
                                :name="offer.params.workSchedule.name"
                                :value="offer.params.workSchedule.string"
                            />
                        </div>
                    </div>
                </div>
                <span class="se-btn lds-widget-card__btn">{{ textBtn }}</span>
            </div>
        </div>
    </a>
</template>

<script setup>
import { inject } from 'vue';
import ShowcaseOffersAdvantage from '../ShowcaseOfferParams/ShowcaseOffersAdvantage.vue';
import ShowcaseOfferParams from '../ShowcaseOfferParams/ShowcaseOfferParams.vue';
import commonProps from '../../common/сommonProps.js';
import advantagesPlacement from '../../common/advantagesPlacement.js';
// import { cookieStore } from '@/scripts/cookie.ts';
import showcaseOfferClasses from '../../common/showcaseOfferClasses.js';

const props = defineProps({
    offer: {
        type: Object,
        required: true,
    },
    ...commonProps(),
});

const currencySymbol = inject('currencySymbol');
const { offerClasses } = showcaseOfferClasses(props);

function transformUrl(url) {
    return cookieStore.transformUrl(url);
}

</script>
<style lang="scss" scoped>
@import '../../assets/styles/design1/offer';
</style>